import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { FAQ_CONTENT } from '../../content/site';
import { EASE } from '../ui/Primitives';
export function FaqAccordion({
  limit
}: {
  limit?: number;
}) {
  const {
    language
  } = useLanguage();
  const t = FAQ_CONTENT[language];
  const items = limit ? t.faqs.slice(0, limit) : t.faqs;
  const [open, setOpen] = useState<number | null>(0);
  return <div className="divide-y divide-espresso/10 border-y border-espresso/10" data-id="element-71" data-mp="17xgdn7clu09x">
      {items.map((faq, index) => {
      const isOpen = open === index;
      return <div key={faq.question} data-id="element-72" data-mp="1hve1htqjxv20" data-mpi={index}>
            <h3 data-id="element-73" data-mp="1hwfmapxddvwx">
              <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="group flex w-full items-start justify-between gap-8 py-6 text-left" data-id="element-74" data-mp="1hsrt5rvu7biq">
                <span className="flex-1 font-serif text-lg font-light leading-snug text-espresso lg:text-xl" data-id="element-75" data-mp="2v7uqaqdr61r2">
                  {faq.question}
                </span>
                <span className="mt-1 shrink-0 text-espresso/35 transition-colors group-hover:text-bronze" data-id="element-76" data-mp="2m87q27wrf1zl">
                  {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-77" data-mp="2h8v19hmbvkud" /> : <PlusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-78" data-mp="2cb39qopli0qp" />}
                </span>
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-79" data-mp="23hzq1yocwrnm">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.35,
            ease: EASE
          }} className="overflow-hidden" data-id="element-80" data-mp="23fvo3ma0q2pz">
                  <p className="max-w-3xl pb-7 pr-10 text-sm font-light leading-relaxed text-espresso/65 lg:text-base" data-id="element-81" data-mp="1ex3dhp2xsgki">
                    {faq.answer}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}